import { useState } from "react";
import { Bell, CalendarPlus, Coffee, MessageCircle, Stethoscope, Users } from "lucide-react";

// Палитра как у баннера консьержа: ночная бирюза, янтарь, крем
const BG = "linear-gradient(135deg, #002C2B 0%, #004F4E 100%)";
const AMBER = "#C9893A";
const CREAM = "#F0EDE6";
const CHAMPAGNE = "#E8DCC8";
const IMG = "/assets/guest-invite-cat.webp";

const TILES = [
  { icon: Bell, title: "Афиша под твои интересы", text: "Выбирай темы и узнавай о новом в своём городе" },
  { icon: Users, title: "Сообщества и встречи", text: "Люди, с которыми есть что обсудить и куда сходить" },
  { icon: Coffee, title: "Кофе-знакомства", text: "Начни с одной встречи за чашкой кофе" },
  { icon: Stethoscope, title: "Эксперты на русском", text: "Врачи, юристы, мастера: найди под свой запрос" },
  { icon: MessageCircle, title: "Спроси своих", text: "Вопросы и советы, работа, подрядчики и барахолка" },
  { icon: CalendarPlus, title: "Расскажи о своём деле", text: "Размести событие или услугу, чтобы о них узнали" },
];

function Cat({ size }: { size: number }) {
  const [failed, setFailed] = useState(false);
  if (failed) return null;
  return (
    <img
      decoding="async"
      src={IMG}
      alt=""
      width={size}
      height={size}
      onError={() => setFailed(true)}
      className="shrink-0 rounded-full object-cover"
      loading="lazy"
    />
  );
}

/** Постоянный блок-приглашение для гостей афиши. Не закрывается, без пауз. */
export function GuestInviteBlock({ onSignup, onLogin, className }: {
  onSignup: () => void;
  onLogin: () => void;
  className?: string;
}) {
  return (
    <section
      aria-label="Приглашение в TurkeyDrive"
      className={`relative min-w-0 overflow-hidden rounded-3xl border p-4 sm:p-5 ${className ?? ""}`}
      style={{ backgroundImage: BG, borderColor: "rgba(201,137,58,0.5)" }}
    >
      <div className="flex items-center gap-3">
        <Cat size={64} />
        <div className="min-w-0">
          <h2 className="break-words font-serif text-xl font-bold leading-tight" style={{ color: CREAM }}>
            Есть куда пойти? Найди и своих 🐾
          </h2>
          <p className="mt-1 break-words text-[13px] leading-snug" style={{ color: CHAMPAGNE }}>
            Зарегистрируйся в TurkeyDrive: отмечай «Я иду», находи сообщества и решай повседневные вопросы в Турции.
          </p>
        </div>
      </div>

      <div className="mt-4 grid grid-cols-2 gap-2">
        {TILES.map(({ icon: Icon, title, text }) => (
          <div
            key={title}
            className="flex min-w-0 items-start gap-2 rounded-xl p-2.5"
            style={{ background: "rgba(240,237,230,0.08)" }}
          >
            <Icon className="mt-0.5 h-4 w-4 shrink-0" style={{ color: AMBER }} aria-hidden />
            <div className="min-w-0">
              <p className="break-words text-[12px] font-semibold leading-snug" style={{ color: CREAM }}>{title}</p>
              <p className="mt-0.5 break-words text-[11px] leading-snug" style={{ color: CHAMPAGNE }}>{text}</p>
            </div>
          </div>
        ))}
      </div>

      <p className="mt-4 text-center text-[13px] italic" style={{ color: CHAMPAGNE }}>
        Почувствуй себя в Турции как дома
      </p>
      <button
        type="button"
        onClick={onSignup}
        className="mt-2 flex h-12 w-full items-center justify-center rounded-full bg-td-orange text-base font-semibold text-white hover:bg-td-orange/90"
      >
        Присоединиться бесплатно
      </button>
      <button
        type="button"
        onClick={onLogin}
        className="mt-1 flex min-h-11 w-full items-center justify-center text-[13px]"
        style={{ color: CHAMPAGNE }}
      >
        Уже с нами? <span className="ml-1 font-semibold underline" style={{ color: AMBER }}>Войти</span>
      </button>
    </section>
  );
}
